import * as CL from '@design-system/component-library';
import { getCharacteristicOptions } from '../PlaceOrder/utils/runtimeCharacteristicsCoCo.js';
import type { CLSelectGroupProduct } from '../../common/types/componentLibrary.js';
import type { ProductOfferingCharacteristic } from '../../generated/api/productOfferingCharacteristic.js';

import './ProductOfferingCharacteristicSelectorCoCo.scss';
import '../ProductOfferingModalCoCo/FixedBroadbandModalCoCo.scss';

export interface ProductOfferingCharacteristicSelectorCoCoProps {
  characteristics: ProductOfferingCharacteristic[];
  characteristicName: string;
  heading: string;
  description?: string;
  selectedValue: string | undefined;
  onValueChange: (value: string) => void;
}

export const ProductOfferingCharacteristicSelectorCoCo = ({
  characteristics,
  characteristicName,
  heading,
  description,
  selectedValue,
  onValueChange,
}: ProductOfferingCharacteristicSelectorCoCoProps) => {
  const options = getCharacteristicOptions(characteristics, characteristicName);

  if (options.length === 0) {
    return null;
  }

  const products: CLSelectGroupProduct[] = options.map(option => ({
    id: option.value,
    value: option.value,
    name: option.label,
    selected: selectedValue === option.value,
  }));

  return (
    <div className="of-modal-section">
      <div className="of-modal-section__heading">
        {heading}
        {description && (
          <CL.Tooltip
            triggerElement={<CL.Icon icon="information" size="s" />}
            placement="top"
            i18n_tooltip_contentText={description}
          />
        )}
      </div>
      <CL.SelectGroup
        className="of-characteristic-selector__group"
        products={products}
        onChange={value => {
          if (value) {
            onValueChange(String(value));
          }
        }}
        value={selectedValue}
        wrapText={true}
      />
    </div>
  );
};
